import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson = () => {
  let initData: any = {
    table: "coolen_con",
    list_id: "coolen_con_word_m_list",
    x_column_list_arr: [
      { "key": "row_view_order", "name": "순서", "width": "50", "is_show": "1" },
      // { "key": "cont_no", "name": "순번", "width": "70", "is_show": "1" },
      { "key": "e_script", "name": "단어", "width": "320", "is_show": "1" },
      { "key": "k_script", "name": "뜻", "width": "320", "is_show": "1" },
      { "key": "mp3_file", "name": "mp3", "width": "250", "is_show": "1" },
      { "key": "mp3_file_url", "name": "mp3_url", "width": "250", "is_show": "1" },
      { "key": "include", "name": "사용여부", "width": "70", "is_show": "1" },
      { "key": "row_view_manage", "name": "관리", "width": "100", "is_show": "1" },
    ],
    list_opt_origin: {
      'now_page': 1,
      'num_per_page': 20,
      'order_id': 'cont_no',
      'order_type': '',
      's_date_type': '',
      's_start_date': '',
      's_end_date': '',
      'sc': {},
    },
    order_id_col_arr: [
      { "value": "", "text": "없음" },
    ]
  };
  initData.pri_col_arr = ["uid"];
  const xColumnArr: any = XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;